import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function ConsistentIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3688" data-mp="1yiusd7wpwu6q">
      <div className="relative w-full h-full bg-gradient-to-br from-blue-50 to-indigo-100 overflow-hidden" data-id="element-3689" data-mp="2r55z70ax3rbz">
        {/* Background: Giant Calendar */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3690" data-mp="2cg9kwli9pi2x">
          <g transform="translate(40, 20) scale(1.2)" data-id="element-3691" data-mp="354f619d8h93a">
            {/* Calendar Board */}
            <rect x="0" y="10" width="100" height="100" rx="8" fill="#FFFFFF" stroke="#CBD5E1" strokeWidth="2" data-id="element-3692" data-mp="39wytcy1q3ila" />
            <rect x="0" y="10" width="100" height="25" rx="8" fill="#EF4444" data-id="element-3693" data-mp="8g4t78mpnbih" />
            <rect x="0" y="25" width="100" height="10" fill="#EF4444" data-id="element-3694" data-mp="mb76whxsu55u" />

            {/* Rings */}
            <rect x="20" y="0" width="6" height="20" rx="3" fill="#94A3B8" data-id="element-3695" data-mp="hhcr3plbeac1" />
            <rect x="74" y="0" width="6" height="20" rx="3" fill="#94A3B8" data-id="element-3696" data-mp="w6r02wkzapqw" />

            {/* Grid */}
            <path d="M0 55 L100 55 M0 75 L100 75 M0 95 L100 95" stroke="#E2E8F0" strokeWidth="1" data-id="element-3697" data-mp="r7nvtectonjz" />
            <path d="M25 35 L25 110 M50 35 L50 110 M75 35 L75 110" stroke="#E2E8F0" strokeWidth="1" data-id="element-3698" data-mp="1565n1m1xsi6n" />

            {/* Checkmarks */}
            {isUnlocked && <g stroke="#22C55E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-3699" data-mp="32yjhyc3bg34e">
                <path d="M5 45 L10 50 L20 40" data-id="element-3700" data-mp="1aw70jrwwjvrp" />
                <path d="M30 45 L35 50 L45 40" data-id="element-3701" data-mp="1awywx4ybpxj1" />
                <path d="M55 45 L60 50 L70 40" data-id="element-3702" data-mp="1fva6rfomc819" />
                <path d="M80 45 L85 50 L95 40" data-id="element-3703" data-mp="1fui7nuvtbs68" />

                <path d="M5 65 L10 70 L20 60" data-id="element-3704" data-mp="1kvfr0ask6s9b" />
                <path d="M30 65 L35 70 L45 60" data-id="element-3705" data-mp="1kw7ltjec0lyj" />
                <path d="M55 65 L60 70 L70 60" data-id="element-3706" data-mp="1ox19qcrry0rf" />
                <path d="M80 65 L85 70 L95 60" data-id="element-3707" data-mp="1ow7zv2xiqv52" />
              </g>}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[5%]" data-id="element-3708" data-mp="1ymb2luufzngl">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3709" data-mp="1yodzmyu0igut">
            <DjaySpecimen look={{
            variant,
            accessory: 'trophy'
          }} size="hero" emotion={isUnlocked ? 'excited' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3710" data-mp="23kumlpph6p6b" />
          </div>
        </div>

        {/* Foreground: Desk/Floor */}
        <svg className="absolute bottom-0 left-0 w-full h-1/5 z-20 pointer-events-none" viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-3711" data-mp="3t1q9hrpflh17">
          <path d="M0 20 L200 20 L200 40 L0 40 Z" fill="#94A3B8" opacity="0.2" data-id="element-3712" data-mp="3j6olx0at0n0q" />
        </svg>
      </div>
    </DjayIllustrationBase>;
}